import { Component, OnInit, inject } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog'
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table'
import { CarrierData } from '../../../api/model/backend.model'
import { ProgramInitiationMappingActionDialogComponent } from '../../components/program-initiation-mapping-action-dialog/program-initiation-mapping-action-dialog.component'
import { AccountMappingData } from '../../model/program-initiation.model'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { ButtonComponent } from '../../../shared/button/button.component'

@Component({
  selector: 'app-program-initiation-mapping-dialog',
  templateUrl: './program-initiation-mapping-dialog.component.html',
  styleUrls: ['./program-initiation-mapping-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    ButtonComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatDialogClose,
  ],
})
export class ProgramInitiationMappingDialogComponent implements OnInit {
  private dialog = inject(MatDialog)
  dialogRef = inject<MatDialogRef<ProgramInitiationMappingDialogComponent>>(MatDialogRef)
  data = inject<{
    carriers: CarrierData[]
    accountMappingData: AccountMappingData[]
  }>(MAT_DIALOG_DATA)

  dataSource: MatTableDataSource<AccountMappingData>
  displayedColumns: string[] = ['Account Name', 'Carrier Name', 'deleteAction']

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.data.accountMappingData)
  }

  onMappingActionClick(accountMappingData: AccountMappingData): void {
    const dialogRef = this.dialog.open(ProgramInitiationMappingActionDialogComponent, {
      data: {
        carriers: this.data.carriers,
        accountMappingData,
      },
    })
    dialogRef.afterClosed().subscribe((updatedMapping: AccountMappingData) => {
      if (!updatedMapping) {
        return
      }
      this.dialogRef.close(updatedMapping)
    })
  }
}
